import { useTranslation } from "@/Common/CustomHooks/useTranslation";
import { IDirectoryEntity } from "@/ContactDirectory/Models/IDirectoryEntity";
import { EstablishmentFaxNumbersList } from "./EstablishmentFaxNumbersList";

import styles from "./EstablishmentFaxNumbersList.module.scss";

interface IDisplayFaxnumbersProps {
    entity: IDirectoryEntity;
    onSelectFaxNumber: (faxNumberId: string) => void;
    showAllFaxNumbers: boolean;
    onShowAllFaxNumbers: (showLess: boolean) => void;
}

export function DisplayFaxNumbers(props: IDisplayFaxnumbersProps): JSX.Element {
    const { getText } = useTranslation();

    return (
        <>
            {!props.showAllFaxNumbers ? (
                <a
                    className={styles.showFaxNumbersLink}
                    onClick={(e: React.MouseEvent) => {
                        e.stopPropagation();
                        props.onShowAllFaxNumbers(true);
                    }}
                >
                    {getText("ContactDirectory_ShowAllFaxNumbers")}
                </a>
            ) : (
                <>
                    <a
                        className={styles.showFaxNumbersLink}
                        onClick={(e: React.MouseEvent) => {
                            e.stopPropagation();
                            props.onShowAllFaxNumbers(false);
                        }}
                    >
                        {getText("ContactDirectory_ShowLessFaxNumbers")}
                    </a>
                    <EstablishmentFaxNumbersList
                        entityId={props.entity.id}
                        faxNumbers={props.entity.getFaxNumbersModels()}
                        onSelectFaxNumber={faxNumberId => props.onSelectFaxNumber(faxNumberId)}
                    />
                </>
            )
            }
        </>
    );
}
